module.exports = "//__CDN_HOST__/2.0.8/img/More-3.cf4375a8.png";